export interface TourStoryType {
  id: string;
  type?: string;
  url: string;
  options?: string;
  countries: string;
  totalView?: string;
  disabled?: string;
  createdAt?: string;
  isSwitchVideo?: boolean;
  index: number;
  sortOrder?: number;
}

export interface FormTourStoryType extends TourStoryType {}

export enum TourStoryStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum TourStoryURLType {
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
}
